// import React, { useState, useEffect } from "react";
// import { logApi } from "../../api/Api";

// const Load3Svg = ({ svgColor }) => {
//     const [logData, setLogData] = useState(null); // Initialize as null or an object
//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID"),
//         LOC_CODE: localStorage.getItem("LCODE"),
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     const fetchLogData = async () => {
//         try {
//             const res = await logApi(credentials);
//             if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//                 // Assuming you need the first object in the array
//                 setLogData(res.TOT_LIVE_KW_NEW[0]);
//             } else {
//                 setLogData(null); // Handle no data scenario
//             }
//         } catch (error) {
//             console.error("Error fetching log data:", error);
//             setLogData(null); // Handle error scenario
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials]);



//     // Determine the color for the SOLAR value
//     const solarColor =
//         logData?.SOLAR == null
//             ? "gray" // No data
//             : logData.SOLAR <= 0
//                 ? "red" // Solar < 1
//                 : "green"; // Solar >= 1

//     // Determine the color for the LOAD value
//     const loadColor =
//         logData?.TOTAL_LOAD == null
//             ? "gray" // No data
//             : logData.TOTAL_LOAD <= 0
//                 ? "red" // Solar < 1
//                 : "green"; // Solar >= 1


//     // Determine the color for the DG value
//     const dgColor =
//         logData?.GenSet == null
//             ? "gray" // No data
//             : logData.GenSet <= 0
//                 ? "red" // Solar <= 0
//                 : "green"; // Solar > 0




//     return (
//         <>
            // <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            //     width="100%" height="100%" viewBox="0 0 865.000000 545.000000"
            //     preserveAspectRatio="xMidYMid meet">

//                 <g transform="translate(0.000000,1689.000000) scale(0.100000,-0.100000)"
//                     fill="#000000" stroke="none">
//                     <path d="M920 16575 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
// -6 4 -10 -8 -10 -30z"/>
//                     <path d="M7022 16602 c-7 -5 -33 -67 -58 -138 l-45 -129 -109 -110 c-103 -105
// -140 -155 -140 -190 0 -22 28 -19 35 5 3 11 13 20 20 20 8 0 19 -9 25 -20 13
// -23 30 -26 30 -5 0 17 30 35 59 35 12 0 21 5 21 10 0 6 -27 10 -60 10 -33 0
// -60 3 -60 8 0 10 153 162 163 162 4 0 7 -48 7 -108 l0 -107 -91 -90 c-50 -50
// -104 -108 -120 -129 -31 -42 -39 -86 -14 -86 8 0 15 6 15 13 0 19 20 36 36 30
// 8 -3 14 -14 14 -24 0 -10 7 -19 15 -19 8 0 15 7 15 15 0 17 30 35 60 35 13 0
// 20 5 18 13 -3 7 -27 13 -63 15 l-58 3 79 80 c43 43 82 79 86 79 5 0 8 -49 8
// -109 l0 -109 -66 -169 c-36 -92 -71 -180 -78 -194 l-13 -26 81 -7 c196 -15
// 554 -3 537 18 -5 6 -41 91 -80 189 l-72 179 -1 109 c-1 60 2 112 6 116 4 4 44
// -30 89 -75 l82 -82 -63 0 c-48 0 -62 -3 -62 -15 0 -9 9 -15 25 -15 14 0 34 -9
// 46 -21 l21 -21 20 22 c16 17 23 19 34 9 8 -6 14 -18 14 -25 0 -8 7 -14 15 -14
// 8 0 15 8 15 19 0 30 -46 90 -146 191 l-94 96 -2 102 c0 56 2 106 7 110 7 7
// 155 -143 155 -159 0 -5 -22 -9 -49 -9 -28 0 -52 -4 -55 -9 -7 -10 16 -21 44
// -21 10 0 22 -9 25 -20 3 -11 10 -20 15 -20 5 0 14 9 20 20 6 11 17 20 25 20 7
// 0 17 -9 20 -20 12 -39 41 -16 31 25 -4 14 -60 80 -126 148 l-120 124 -40 114
// c-52 144 -61 159 -103 159 -17 0 -38 -4 -45 -8z m110 -136 c21 -61 36 -116 34
// -123 -4 -9 -30 -13 -95 -13 -49 0 -96 3 -104 6 -13 4 -9 22 20 110 37 112 54
// 137 86 132 15 -2 28 -27 59 -112z m8 -179 c0 -7 -17 -30 -38 -50 l-38 -37 -49
// 50 -49 50 87 0 c65 0 87 -3 87 -13z m-142 -154 c-23 -24 -46 -43 -50 -43 -9 0
// -11 115 -2 148 7 23 8 22 50 -19 l44 -43 -42 -43z m182 40 l0 -87 -45 44 -45
// 44 42 43 c23 24 43 43 45 43 2 0 3 -39 3 -87z m-71 -67 c18 -19 30 -39 27 -45
// -4 -7 -41 -11 -89 -11 l-81 0 44 45 c24 25 49 45 55 45 6 0 26 -15 44 -34z
// m31 -94 c0 -4 -18 -26 -40 -47 l-40 -39 -48 47 -47 47 88 0 c48 0 87 -4 87 -8z
// m-142 -159 c-23 -24 -46 -43 -50 -43 -9 0 -11 131 -2 155 6 14 14 9 50 -26
// l44 -43 -42 -43z m182 40 l0 -87 -45 44 -45 44 42 43 c23 24 43 43 45 43 2 0
// 3 -39 3 -87z m-62 -190 l-58 -58 -55 55 -55 54 57 58 58 58 55 -55 55 -55 -57
// -57z m-168 -170 c-108 -114 -141 -145 -146 -140 -5 4 96 270 117 309 11 20 13
// 19 62 -30 l51 -51 -84 -88z m288 90 c62 -151 85 -214 78 -221 -4 -3 -57 44
// -118 105 l-111 111 48 51 c26 28 51 51 55 51 4 0 26 -44 48 -97z m32 -245 c0
// -5 -92 -8 -205 -8 -113 0 -205 3 -205 7 0 4 46 54 102 110 l103 103 102 -102
// c57 -57 103 -106 103 -110z"
                        // fill={
                        //     logData?.GRID == null
                        //         ? "gray" // No data
                        //         : logData.GRID <= 0
                        //             ? "red" // Grid < 1
                        //             : "green" // Grid > 0
                        // }
//                     />
//                     <path d="M790 16567 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
// -20 6z" fill={solarColor} />
//                     <path d="M1042 16558 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
// -7z" fill={solarColor} />
//                     <path d="M865 16476 c-44 -20 -72 -55 -86 -107 -11 -41 -10 -50 7 -84 11 -21
// 34 -49 51 -62 l32 -25 11 44 c7 23 19 60 27 80 l15 38 84 0 c46 0 84 2 84 5 0
// 4 -6 18 -14 33 -40 76 -136 111 -211 78z" fill={solarColor} />
//                     <path d="M680 16470 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
// -10z" fill={solarColor} />
//                     <path d="M1128 16464 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
// -31 -4z" fill={solarColor} />
//                     <path d="M660 16350 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
// -16 0 -30 -4 -30 -10z" fill={solarColor} />
//                     <path d="M926 16283 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
// 50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor} />
//                     <path d="M1086 16299 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
// c-63 0 -64 0 -70 -31z" fill={solarColor} />
//                     <path d="M1256 16314 c-3 -9 -6 -31 -6 -50 l0 -34 80 0 80 0 0 50 0 50 -74 0
// c-58 0 -75 -3 -80 -16z" fill={solarColor} />
//                     <path d="M1450 16280 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor} />
//                     <path d="M1607 16323 c-2 -5 1 -26 7 -48 l12 -40 62 -3 c68 -3 69 -3 50 59
// l-11 39 -58 0 c-32 0 -60 -3 -62 -7z" fill={solarColor} />
//                     <path d="M709 16241 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
// -41 -6z" fill={solarColor} />
//                     <path d="M1140 16191 l-74 -6 -7 -35 c-4 -19 -6 -36 -5 -37 1 -2 36 -4 77 -5
// l74 -3 5 48 c3 26 6 46 5 45 0 -1 -34 -4 -75 -7z" fill={solarColor} />
//                     <path d="M890 16163 c-6 -16 -15 -36 -21 -46 -10 -18 -6 -18 68 -12 43 4 79 9
// 81 10 2 1 6 19 9 39 l6 36 -67 0 c-64 0 -67 -1 -76 -27z" fill={solarColor} />
//                     <path d="M1247 16183 c-4 -3 -7 -24 -7 -45 l0 -38 79 0 c104 0 107 2 103 50
// l-4 40 -82 0 c-46 0 -86 -3 -89 -7z" fill={solarColor} />
//                     <path d="M1460 16151 c0 -45 11 -51 101 -51 l57 0 -8 34 c-12 53 -17 56 -86
// 56 l-64 0 0 -39z" fill={solarColor} />
//                     <path d="M1630 16183 c0 -5 5 -25 11 -45 l10 -38 69 0 c39 0 70 3 70 8 0 4 -5
// 24 -11 45 l-10 37 -69 0 c-39 0 -70 -3 -70 -7z" fill={solarColor} />
//                     <path d="M814 16172 c-6 -4 -16 -17 -23 -29 -16 -32 5 -39 25 -9 17 27 16 50
// -2 38z" fill={solarColor} />
//                     <path d="M2298 16133 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
//                     <path d="M2468 16133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2638 16133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2808 16133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2953 16090 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M837 16017 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
// c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor} />
//                     <path d="M1043 16058 c-13 -16 -33 -105 -25 -113 3 -3 43 -5 89 -5 l84 0 -3
// 63 -3 62 -66 3 c-45 2 -69 -1 -76 -10z" fill={solarColor} />
//                     <path d="M1230 16000 l0 -60 105 0 105 0 0 38 c0 82 -1 82 -111 82 l-99 0 0
// -60z" fill={solarColor} />
//                     <path d="M1467 16053 c-2 -5 -2 -32 1 -60 l4 -53 89 0 c100 0 97 -2 78 76
// l-11 44 -79 0 c-43 0 -80 -3 -82 -7z" fill={solarColor} />
//                     <path d="M1660 16058 c1 -2 7 -28 14 -58 l12 -55 81 -3 81 -3 -15 61 -15 60
// -79 0 c-44 0 -79 -1 -79 -2z" fill={solarColor} />
//                     <path d="M5284 15969 c-3 -6 -1 -16 5 -22 8 -8 11 -8 11 0 0 6 12 16 28 21
// l27 10 -32 1 c-17 1 -35 -4 -39 -10z" fill={svgColor} />
//                     <path d="M5458 15973 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M5628 15973 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M5798 15973 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2953 15930 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M789 15863 c-11 -26 -21 -59 -22 -73 -2 -25 -1 -25 83 -28 l86 -3 12
// 53 c23 98 27 93 -61 96 l-77 3 -21 -48z" fill={solarColor} />
//                     <path d="M1013 15902 c-7 -4 -19 -34 -28 -67 -12 -46 -12 -61 -2 -67 6 -4 54
// -8 105 -8 l92 0 0 29 c0 15 3 49 6 75 l7 46 -84 0 c-46 0 -89 -4 -96 -8z" fill={solarColor} />
//                     <path d="M1216 15864 c-3 -26 -6 -60 -6 -75 l0 -29 120 0 120 0 0 44 c0 24 -3
// 58 -6 75 l-6 31 -108 0 -107 0 -7 -46z" fill={solarColor} />
//                     <path d="M1474 15878 c19 -123 13 -118 126 -118 99 0 99 0 69 113 l-10 37 -95
// 0 -95 0 5 -32z" fill={solarColor} />
//                     <path d="M1700 15878 c5 -18 14 -52 21 -75 l11 -43 72 1 c109 1 109 1 83 79
// l-23 65 -86 3 -86 3 8 -33z" fill={solarColor} />
//                     <path d="M5283 15834 c-3 -8 -1 -20 6 -27 8 -8 11 -4 11 16 0 30 -7 35 -17 11z" fill={svgColor} />
//                     <path d="M2953 15760 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M1310 15655 c0 -73 1 -75 25 -75 24 0 25 2 25 75 0 73 -1 75 -25 75
// -24 0 -25 -2 -25 -75z" fill={solarColor} />
//                     <path d="M5283 15664 c-3 -8 -1 -20 6 -27 8 -8 11 -4 11 16 0 30 -7 35 -17 11z" fill={svgColor} />
//                     <path d="M2953 15585 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
//                     <path d="M980 15495 l-85 -44 381 0 c210 -1 403 2 429 6 l48 6 -83 39 -83 38
// -261 -1 -261 0 -85 -44z" fill={solarColor} />
//                     <path d="M5280 15480 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20
// -5 0 -10 -9 -10 -20z" fill={svgColor} />
//                     <path d="M2952 15420 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
//                     <path d="M5280 15310 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20
// -5 0 -10 -9 -10 -20z" fill={svgColor} />
//                     <path d="M920 15095 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
// -6 4 -10 -8 -10 -30z" fill={solarColor} />
//                     <path d="M2953 15085 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
//                     <path d="M790 15087 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
// -20 6z" fill={solarColor} />
//                     <path d="M1042 15078 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
// -7z" fill={solarColor} />
//                     <path d="M865 14996 c-44 -20 -72 -55 -86 -107 -11 -41 -10 -50 7 -84 11 -21
// 34 -49 51 -62 l32 -25 11 44 c7 23 19 60 27 80 l15 38 84 0 c46 0 84 2 84 5 0
// 4 -6 18 -14 33 -40 76 -136 111 -211 78z" fill={solarColor} />
//                     <path d="M680 14990 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
// -10z" fill={solarColor} />
//                     <path d="M1128 14984 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
// -31 -4z" fill={solarColor} />

//                     {/* //ye arrow bala code hai */}
//                     <path d="M3524 14956 c32 -55 32 -62 0 -120 l-26 -46 51 20 c65 25 171 79 171
// 86 0 5 -204 104 -215 104 -4 0 5 -20 19 -44z" fill={svgColor} />

//                     <path d="M4026 14959 c-188 -76 -298 -266 -267 -459 29 -180 168 -319 351
// -352 142 -25 311 50 393 175 153 231 71 513 -184 632 -46 21 -68 25 -149 24
// -71 0 -107 -5 -144 -20z m300 -44 c82 -40 166 -127 194 -202 93 -245 -58 -503
// -317 -538 -102 -13 -241 42 -316 126 -70 77 -91 130 -95 239 -2 53 1 114 7
// 137 18 66 89 163 151 206 76 53 128 67 231 64 70 -2 96 -8 145 -32z" fill={svgColor} />

//                     <path d="M5280 14961 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5
// 0 -10 -4 -10 -9z" fill={svgColor} />
//                     <path d="M2950 14928 c0 -15 5 -30 11 -33 18 -12 20 1 4 31 l-15 29 0 -27z" fill={svgColor} />
//                     <path d="M3098 14893 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M3263 14893 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M3433 14893 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M660 14870 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
// -16 0 -30 -4 -30 -10z" fill={solarColor} />
//                     <path d="M926 14803 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
// 50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor} />
//                     <path d="M1086 14819 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
// c-63 0 -64 0 -70 -31z" fill={solarColor} />
//                     <path d="M1256 14834 c-3 -9 -6 -31 -6 -50 l0 -34 80 0 80 0 0 50 0 50 -74 0
// c-58 0 -75 -3 -80 -16z" fill={solarColor} />
//                     <path d="M1450 14800 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor} />
//                     <path d="M1607 14843 c-2 -5 1 -26 7 -48 l12 -40 62 -3 c68 -3 69 -3 50 59
// l-11 39 -58 0 c-32 0 -60 -3 -62 -7z" fill={solarColor} />
//                     <path d="M5283 14814 c-3 -8 -1 -20 6 -27 8 -8 11 -4 11 16 0 30 -7 35 -17 11z" fill={svgColor} />
//                     <path d="M709 14761 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
// -41 -6z" fill={solarColor} />
//                     <path d="M4663 14733 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M4833 14733 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M5008 14733 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M5173 14733 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M1140 14711 l-74 -6 -7 -35 c-4 -19 -6 -36 -5 -37 1 -2 36 -4 77 -5
// l74 -3 5 48 c3 26 6 46 5 45 0 -1 -34 -4 -75 -7z" fill={solarColor} />
//                     <path d="M890 14683 c-6 -16 -15 -36 -21 -46 -10 -18 -6 -18 68 -12 43 4 79 9
// 81 10 2 1 6 19 9 39 l6 36 -67 0 c-64 0 -67 -1 -76 -27z" fill={solarColor} />
//                     <path d="M1247 14703 c-4 -3 -7 -24 -7 -45 l0 -38 79 0 c104 0 107 2 103 50
// l-4 40 -82 0 c-46 0 -86 -3 -89 -7z" fill={solarColor} />
//                     <path d="M1460 14671 c0 -45 11 -51 101 -51 l57 0 -8 34 c-12 53 -17 56 -86
// 56 l-64 0 0 -39z" fill={solarColor} />
//                     <path d="M1630 14703 c0 -5 5 -25 11 -45 l10 -38 69 0 c39 0 70 3 70 8 0 4 -5
// 24 -11 45 l-10 37 -69 0 c-39 0 -70 -3 -70 -7z" fill={solarColor} />
//                     <path d="M814 14692 c-6 -4 -16 -17 -23 -29 -16 -32 5 -39 25 -9 17 27 16 50
// -2 38z" fill={solarColor} />
//                     <path d="M3404 14566 c32 -55 32 -62 0 -120 l-26 -46 51 20 c65 25 171 79 171
// 86 0 5 -204 104 -215 104 -4 0 5 -20 19 -44z" fill={svgColor} />

//                     <path d="M837 14537 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
// c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor} />
//                     <path d="M1043 14578 c-13 -16 -33 -105 -25 -113 3 -3 43 -5 89 -5 l84 0 -3
// 63 -3 62 -66 3 c-45 2 -69 -1 -76 -10z" fill={solarColor} />
//                     <path d="M1230 14520 l0 -60 105 0 105 0 0 38 c0 82 -1 82 -111 82 l-99 0 0
// -60z" fill={solarColor} />
//                     <path d="M1467 14573 c-2 -5 -2 -32 1 -60 l4 -53 89 0 c100 0 97 -2 78 76
// l-11 44 -79 0 c-43 0 -80 -3 -82 -7z" fill={solarColor} />
//                     <path d="M1660 14578 c1 -2 7 -28 14 -58 l12 -55 81 -3 81 -3 -15 61 -15 60
// -79 0 c-44 0 -79 -1 -79 -2z" fill={solarColor} />
//                     <path d="M2298 14503 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
//                     <path d="M2468 14503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2638 14503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2808 14503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M2978 14503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor} />
//                     <path d="M3143 14503 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M3313 14503 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
//                     <path d="M789 14383 c-11 -26 -21 -59 -22 -73 -2 -25 -1 -25 83 -28 l86 -3 12
// 53 c23 98 27 93 -61 96 l-77 3 -21 -48z" fill={solarColor} />
//                     <path d="M1013 14422 c-7 -4 -19 -34 -28 -67 -12 -46 -12 -61 -2 -67 6 -4 54
// -8 105 -8 l92 0 0 29 c0 15 3 49 6 75 l7 46 -84 0 c-46 0 -89 -4 -96 -8z" fill={solarColor} />
//                     <path d="M1216 14384 c-3 -26 -6 -60 -6 -75 l0 -29 120 0 120 0 0 44 c0 24 -3
// 58 -6 75 l-6 31 -108 0 -107 0 -7 -46z" fill={solarColor} />
//                     <path d="M1474 14398 c19 -123 13 -118 126 -118 99 0 99 0 69 113 l-10 37 -95
// 0 -95 0 5 -32z" fill={solarColor} />
//                     <path d="M1700 14398 c5 -18 14 -52 21 -75 l11 -43 72 1 c109 1 109 1 83 79
// l-23 65 -86 3 -86 3 8 -33z" fill={solarColor} />
//                     <path d="M4733 14263 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
//                     <path d="M4908 14263 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
//                     <path d="M5078 14263 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
//                     <path d="M5243 14263 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
//                     <path d="M1310 14175 c0 -73 1 -75 25 -75 24 0 25 2 25 75 0 73 -1 75 -25 75
// -24 0 -25 -2 -25 -75z" fill={solarColor} />
//                     <path d="M2941 14143 c0 -27 1 -27 11 -6 6 12 20 24 32 26 14 3 10 5 -11 6
// -30 1 -33 -2 -32 -26z" fill={svgColor} />


//                     <path d="M3103 14163 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
//                     <path d="M3263 14163 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
//                     <path d="M3433 14163 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
//                     {/* // line hai  */}
//                     {/* <path d="M3598 14163 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor}/> */}

//                     {/* <path d="M3598 14163 c12 -55 32 -62 0 -120 l-26 -46 51 20 c65 25 171 79 171
// 86 0 5 -204 104 -215 104 -4 0 5 -20 19 -44z" fill={svgColor}/> */}

//                     <path d="M3598 14163 c32 -55 32 -62 0 -120 l-26 -46 51 20 c65 25 171 79 171
// 86 0 5 -204 104 -215 104 -4 0 5 -20 19 -44z" fill={svgColor} />



//                     <path d="M5312 14140 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
//                     <path d="M980 14015 l-85 -44 381 0 c210 -1 403 2 429 6 l48 6 -83 39 -83 38
// -261 -1 -261 0 -85 -44z" fill={solarColor} />
//                     <path d="M2943 14000 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M5312 13980 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
//                     <path d="M2943 13835 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
//                     <path d="M5312 13810 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
//                     <path d="M7083 13777 c-63 -54 -463 -406 -540 -476 -40 -36 -73 -69 -73 -72 0
// -4 16 -19 35 -33 l35 -27 177 159 c98 87 229 202 291 256 l114 98 21 -19 c12
// -11 87 -76 167 -145 80 -69 203 -178 275 -241 l130 -115 27 31 c15 18 27 34
// 28 37 0 6 -84 81 -437 393 l-212 187 -38 -33z" fill={loadColor} />
//                     <path d="M6670 13619 l0 -110 28 19 c64 47 122 124 122 163 0 33 -14 39 -91
// 39 l-59 0 0 -111z" fill={loadColor} />
//                     <path d="M980 13675 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
// -6 4 -10 -8 -10 -30z" fill={solarColor} />
//                     <path d="M2943 13665 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
//                     <path d="M850 13667 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
// -20 6z" fill={solarColor} />
//                     <path d="M1102 13658 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
// -7z" fill={solarColor} />
//                     <path d="M5312 13640 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
//                     <path d="M925 13576 c-44 -20 -72 -55 -86 -107 -11 -41 -10 -50 7 -84 11 -21
// 34 -49 51 -62 l32 -25 11 44 c7 23 19 60 27 80 l15 38 84 0 c46 0 84 2 84 5 0
// 4 -6 18 -14 33 -40 76 -136 111 -211 78z" fill={solarColor} />
//                     <path d="M740 13570 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
// -10z" fill={solarColor} />
//                     <path d="M1188 13564 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
// -31 -4z" fill={solarColor} />
//                     <path d="M7005 13483 c-60 -52 -161 -142 -222 -200 l-113 -105 0 -298 0 -297
// 139 -8 c77 -4 145 -4 150 0 7 4 11 51 11 118 0 172 -13 158 154 155 l141 -3 9
// -139 9 -138 141 7 c78 4 144 9 149 12 9 5 9 411 0 517 l-6 78 -171 158 c-169
// 156 -266 240 -276 240 -3 -1 -54 -44 -115 -97z" fill={loadColor} />
//                     <path d="M2943 13495 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
//                     <path d="M720 13450 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
// -16 0 -30 -4 -30 -10z" fill={solarColor} />
//                     <path d="M986 13383 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
// 50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor} />
//                     <path d="M1146 13399 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
// c-63 0 -64 0 -70 -31z" fill={solarColor} />
//                     <path d="M1316 13414 c-3 -9 -6 -31 -6 -50 l0 -34 80 0 80 0 0 50 0 50 -74 0
// c-58 0 -75 -3 -80 -16z" fill={solarColor} />
//                     <path d="M1510 13380 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor} />
//                     <path d="M1667 13423 c-2 -5 1 -26 7 -48 l12 -40 62 -3 c68 -3 69 -3 50 59
// l-11 39 -58 0 c-32 0 -60 -3 -62 -7z" fill={solarColor} />
//                     <path d="M769 13341 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
// -41 -6z" fill={solarColor} />
//                     <path d="M5312 13285 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor} />
//                     <path d="M1200 13291 l-74 -6 -7 -35 c-4 -19 -6 -36 -5 -37 1 -2 36 -4 77 -5
// l74 -3 5 48 c3 26 6 46 5 45 0 -1 -34 -4 -75 -7z" fill={solarColor} />
//                     <path d="M950 13263 c-6 -16 -15 -36 -21 -46 -10 -18 -6 -18 68 -12 43 4 79 9
// 81 10 2 1 6 19 9 39 l6 36 -67 0 c-64 0 -67 -1 -76 -27z" fill={solarColor} />
//                     <path d="M1307 13283 c-4 -3 -7 -24 -7 -45 l0 -38 79 0 c104 0 107 2 103 50
// l-4 40 -82 0 c-46 0 -86 -3 -89 -7z" fill={solarColor} />
//                     <path d="M1520 13251 c0 -45 11 -51 101 -51 l57 0 -8 34 c-12 53 -17 56 -86
// 56 l-64 0 0 -39z" fill={solarColor} />
//                     <path d="M1690 13283 c0 -5 5 -25 11 -45 l10 -38 69 0 c39 0 70 3 70 8 0 4 -5
// 24 -11 45 l-10 37 -69 0 c-39 0 -70 -3 -70 -7z" fill={solarColor} />
//                     <path d="M874 13272 c-6 -4 -16 -17 -23 -29 -16 -32 5 -39 25 -9 17 27 16 50
// -2 38z" fill={solarColor} />
//                     <path d="M2943 13150 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M897 13117 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
// c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor} />
//                     <path d="M1103 13158 c-13 -16 -33 -105 -25 -113 3 -3 43 -5 89 -5 l84 0 -3
// 63 -3 62 -66 3 c-45 2 -69 -1 -76 -10z" fill={solarColor} />
//                     <path d="M1290 13100 l0 -60 105 0 105 0 0 38 c0 82 -1 82 -111 82 l-99 0 0
// -60z" fill={solarColor} />
//                     <path d="M1527 13153 c-2 -5 -2 -32 1 -60 l4 -53 89 0 c100 0 97 -2 78 76
// l-11 44 -79 0 c-43 0 -80 -3 -82 -7z" fill={solarColor} />
//                     <path d="M1720 13158 c1 -2 7 -28 14 -58 l12 -55 81 -3 81 -3 -15 61 -15 60
// -79 0 c-44 0 -79 -1 -79 -2z" fill={solarColor} />
//                     <path d="M5312 13135 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor} />
//                     <path d="M5363 13029 c14 -8 22 -8 30 0 8 8 3 11 -18 11 -26 -1 -28 -2 -12
// -11z" fill={svgColor} />
//                     <path d="M5533 13029 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17
// -10z" fill={svgColor} />
//                     <path d="M5703 13029 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17
// -10z" fill={svgColor} />
//                     <path d="M2943 12990 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor} />
//                     <path d="M849 12963 c-11 -26 -21 -59 -22 -73 -2 -25 -1 -25 83 -28 l86 -3 12
// 53 c23 98 27 93 -61 96 l-77 3 -21 -48z" fill={solarColor} />
//                     <path d="M1073 13002 c-7 -4 -19 -34 -28 -67 -12 -46 -12 -61 -2 -67 6 -4 54
// -8 105 -8 l92 0 0 29 c0 15 3 49 6 75 l7 46 -84 0 c-46 0 -89 -4 -96 -8z" fill={solarColor} />
//                     <path d="M1276 12964 c-3 -26 -6 -60 -6 -75 l0 -29 120 0 120 0 0 44 c0 24 -3
// 58 -6 75 l-6 31 -108 0 -107 0 -7 -46z" fill={solarColor} />
//                     <path d="M1534 12978 c19 -123 13 -118 126 -118 99 0 99 0 69 113 l-10 37 -95
// 0 -95 0 5 -32z" fill={solarColor} />
//                     <path d="M1760 12978 c5 -18 14 -52 21 -75 l11 -43 72 1 c109 1 109 1 83 79
// l-23 65 -86 3 -86 3 8 -33z" fill={solarColor} />
//                     <path d="M2477 12929 c8 -8 16 -8 30 0 16 9 14 10 -11 11 -22 0 -27 -3 -19
// -11z" fill={svgColor} />
//                     <path d="M2647 12929 c8 -8 16 -8 30 0 16 9 14 10 -11 11 -22 0 -27 -3 -19
// -11z" fill={svgColor} />
//                     <path d="M2810 12936 c0 -10 28 -13 41 -5 10 6 7 9 -13 9 -16 0 -28 -2 -28 -4z" fill={svgColor} />
//                     <path d="M1370 12755 c0 -73 1 -75 25 -75 24 0 25 2 25 75 0 73 -1 75 -25 75
// -24 0 -25 -2 -25 -75z" fill={solarColor} />
//                     <path d="M1040 12595 l-85 -44 381 0 c210 -1 403 2 429 6 l48 6 -83 39 -83 38
// -261 -1 -261 0 -85 -44z" fill={solarColor} />
//                 </g>
//             </svg>
//         </>
//     );
// };

// export default Load3Svg;



import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const Load3Svg = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
    const solarColor =
        logData?.SOLAR == null
            ? "gray" // No data
            : logData.SOLAR <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1

    // Determine the color for the LOAD value
    const loadColor =
        logData?.TOTAL_LOAD == null
            ? "gray" // No data
            : logData.TOTAL_LOAD <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
        logData?.GenSet == null
            ? "gray" // No data
            : logData.GenSet <= 0
                ? "red" // Solar <= 0
                : "green"; // Solar > 0
               
            

             

    return (
        <>
    
    <svg
  version="1.0"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 865 545"
  preserveAspectRatio="xMidYMid meet"
  style={{
    width: '100%',
    height: 'auto',       // ✅ Allows dynamic scaling
    maxHeight: '25rem',   // ✅ Limit the height (adjust as needed)
    display: 'block',     // ✅ Removes unwanted spacing
  }}
>


<g transform="translate(-100,1610.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
    
<path d="M2550 15915 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
-6 4 -10 -8 -10 -30z" fill={solarColor}/>
<path d="M2420 15907 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
-20 6z" fill={solarColor}/>
<path d="M2672 15898 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
-7z" fill={solarColor}/>
<path d="M7997 15833 c-8 -16 -31 -77 -52 -138 l-39 -110 -106 -110 c-120
-124 -140 -150 -140 -182 0 -28 26 -31 33 -3 3 11 12 20 20 20 9 0 19 -9 22
-20 8 -25 35 -26 35 -1 0 21 19 31 56 31 13 0 24 5 24 10 0 6 -27 10 -60 10
-33 0 -60 3 -60 8 0 10 153 162 163 162 4 0 7 -48 7 -108 l0 -107 -106 -105
c-58 -58 -112 -117 -120 -132 -18 -35 -18 -68 1 -68 8 0 15 9 15 19 0 20 17
31 38 24 6 -3 12 -13 12 -24 0 -10 7 -19 15 -19 8 0 15 9 15 19 0 21 19 31 57
31 50 0 17 25 -40 30 l-57 5 75 78 c41 42 79 77 85 77 6 0 10 -40 10 -108 l0
-107 -78 -197 -79 -196 106 -8 c100 -6 497 -1 506 7 2 3 -32 92 -75 199 l-79
195 0 95 c-1 52 3 101 8 109 8 12 27 -2 91 -65 l82 -79 -63 -5 c-37 -3 -64
-10 -67 -17 -2 -9 7 -13 27 -13 18 0 38 -9 51 -22 l20 -22 16 22 c20 29 32 28
46 -3 15 -34 28 -32 28 5 0 31 -74 123 -189 235 l-51 49 0 91 c0 133 6 135 95
41 41 -44 75 -83 75 -88 0 -4 -24 -8 -54 -8 -30 0 -57 -4 -60 -9 -7 -10 16
-21 44 -21 9 0 25 -10 33 -22 l16 -23 21 25 20 25 20 -25 c16 -21 22 -22 29
-11 17 26 -11 68 -130 194 l-115 122 -38 110 c-51 147 -57 155 -106 155 -33 0
-42 -4 -53 -27z m123 -117 c23 -63 39 -120 35 -125 -7 -13 -184 -15 -203 -3
-10 7 -4 32 24 113 41 118 48 129 79 129 20 0 28 -14 65 -114z m10 -179 c0 -7
-17 -30 -38 -50 l-38 -37 -49 50 -49 50 87 0 c65 0 87 -3 87 -13z m-148 -64
c21 -20 38 -42 38 -47 0 -12 -71 -86 -82 -86 -4 0 -8 38 -8 85 0 47 3 85 7 85
4 0 24 -17 45 -37z m188 -50 l0 -87 -45 44 -45 44 42 43 c23 24 43 43 45 43 2
0 3 -39 3 -87z m-73 -68 c19 -19 32 -39 28 -45 -3 -5 -43 -10 -88 -10 l-81 0
44 45 c24 25 48 45 53 45 5 0 25 -16 44 -35z m33 -93 c0 -4 -18 -26 -40 -47
l-40 -39 -48 47 -47 47 88 0 c48 0 87 -4 87 -8z m-142 -75 l42 -43 -43 -42
c-23 -23 -46 -42 -50 -42 -4 0 -7 38 -7 85 0 47 4 85 8 85 4 0 27 -19 50 -43z
m182 -44 l0 -87 -44 43 -45 44 37 43 c20 24 40 43 45 44 4 0 7 -39 7 -87z
m-63 -190 l-57 -58 -56 56 -56 56 58 57 58 57 55 -55 56 -56 -58 -57z m-123
-42 l40 -40 -114 -116 c-63 -63 -116 -113 -118 -110 -3 2 24 76 58 164 70 179
64 174 134 102z m265 -94 c81 -199 81 -199 -55 -65 l-119 118 50 50 c60 61 54
66 124 -103z m11 -189 c0 -5 -92 -8 -205 -8 -167 0 -205 3 -205 14 0 7 46 57
101 111 l102 97 103 -103 c57 -57 104 -107 104 -111z" fill={
    logData?.GRID == null
        ? "gray" // No data
        : logData.GRID <= 0
            ? "red" // Grid < 1
            : "green" // Grid > 0
}/>
<path d="M2495 15816 c-111 -49 -125 -205 -25 -276 l28 -20 21 69 c28 92 38
101 114 101 81 0 94 8 74 46 -20 38 -44 60 -90 79 -44 18 -82 19 -122 1z" fill={solarColor}/>
<path d="M2310 15810 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
-10z" fill={solarColor}/>
<path d="M2758 15804 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
-31 -4z" fill={solarColor}/>
<path d="M2290 15670 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={solarColor}/>
<path d="M2556 15603 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor}/>
<path d="M2716 15619 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
c-63 0 -64 0 -70 -31z" fill={solarColor}/>
<path d="M2887 15643 c-4 -3 -7 -26 -7 -50 l0 -43 80 0 80 0 0 50 0 50 -73 0
c-41 0 -77 -3 -80 -7z" fill={solarColor}/>
<path d="M3080 15600 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor}/>
<path d="M3234 15633 c2 -10 7 -33 11 -50 l7 -33 64 0 c70 0 71 1 52 61 l-11
39 -64 0 c-57 0 -64 -2 -59 -17z" fill={solarColor}/>
<path d="M2339 15561 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
-41 -6z" fill={solarColor}/>
<path d="M2596 15511 l-69 -6 -18 -53 -18 -54 72 7 c39 4 75 10 78 14 4 3 11
27 17 54 5 26 9 46 8 45 0 -1 -32 -4 -70 -7z" fill={solarColor}/>
<path d="M2691 15483 c-19 -68 -18 -70 60 -77 39 -4 73 -5 76 -3 2 3 8 30 12
61 l8 56 -73 0 -73 0 -10 -37z" fill={solarColor}/>
<path d="M2877 15503 c-4 -3 -7 -28 -7 -55 l0 -48 83 0 c45 0 87 4 94 8 7 4 9
24 6 55 l-6 47 -82 0 c-45 0 -85 -3 -88 -7z" fill={solarColor}/>
<path d="M3090 15461 c0 -56 7 -61 103 -61 l58 0 -7 38 c-12 67 -18 72 -89 72
l-65 0 0 -49z" fill={solarColor}/>
<path d="M3264 15484 c4 -15 10 -39 13 -55 5 -29 7 -29 74 -29 37 0 70 3 72 8
2 4 -3 28 -10 55 l-14 47 -71 0 -70 0 6 -26z" fill={solarColor}/>
<path d="M2444 15492 c-18 -11 -35 -50 -25 -56 5 -3 16 6 26 20 17 27 17 48
-1 36z" fill={solarColor}/>
<path d="M2467 15317 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor}/>
<path d="M2672 15358 c-13 -17 -33 -99 -26 -110 3 -4 43 -8 90 -8 l85 0 -3 63
-3 62 -66 3 c-46 2 -69 -1 -77 -10z" fill={solarColor}/>
<path d="M2858 15308 c-3 -29 -3 -56 -1 -60 2 -5 51 -8 109 -8 l104 0 0 38 c0
82 -1 82 -110 82 l-98 0 -4 -52z" fill={solarColor}/>
<path d="M3097 15353 c-3 -5 -2 -32 0 -60 l6 -53 83 0 c47 0 86 5 89 10 4 6 1
33 -5 60 l-12 50 -78 0 c-44 0 -81 -3 -83 -7z" fill={solarColor}/>
<path d="M3290 15358 c1 -2 7 -28 14 -58 l12 -55 69 -3 c37 -2 72 1 78 7 6 6
5 27 -3 60 l-12 51 -79 0 c-43 0 -79 -1 -79 -2z" fill={solarColor}/>
<path d="M2432 15193 c-17 -33 -43 -134 -37 -143 3 -6 43 -10 89 -10 l82 0 13
63 c7 34 15 72 18 85 5 21 3 22 -76 22 -66 0 -82 -3 -89 -17z" fill={solarColor}/>
<path d="M2636 15201 c-3 -5 -12 -40 -20 -77 -11 -52 -12 -71 -3 -76 7 -4 54
-8 105 -8 l92 0 0 39 c0 21 3 59 6 85 l7 46 -91 0 c-50 0 -93 -4 -96 -9z" fill={solarColor}/>
<path d="M2846 15149 c-12 -120 -23 -109 114 -109 l120 0 0 39 c0 21 -3 59 -6
85 l-7 46 -107 0 -107 0 -7 -61z" fill={solarColor}/>
<path d="M3106 15163 c14 -128 9 -123 117 -123 98 0 102 4 86 76 -20 96 -17
94 -119 94 l-90 0 6 -47z" fill={solarColor}/>
<path d="M3324 15193 c3 -10 10 -40 16 -68 19 -90 13 -85 93 -84 109 1 108 0
83 89 l-22 75 -88 3 c-80 3 -87 1 -82 -15z" fill={solarColor}/>
<path d="M3948 15133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor}/>
<path d="M4093 15133 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M4333 15133 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M4478 15133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor}/>
<path d="M6634 15129 c-3 -6 -1 -16 5 -22 8 -8 11 -8 11 1 0 7 10 17 23 22 21
8 21 9 -5 9 -15 1 -30 -4 -34 -10z" fill={svgColor}/>
<path d="M6783 15133 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M6933 15133 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M7073 15133 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M4603 15090 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M6633 15004 c-3 -8 -1 -20 6 -27 8 -8 11 -4 11 16 0 30 -7 35 -17 11z" fill={svgColor}/>
<path d="M2940 14925 c0 -84 0 -85 25 -85 25 0 25 1 25 85 0 84 0 85 -25 85
-25 0 -25 -1 -25 -85z" fill={solarColor}/>
<path d="M4603 14940 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M6633 14844 c-3 -8 -1 -20 6 -27 8 -8 11 -4 11 16 0 30 -7 35 -17 11z" fill={svgColor}/>
<path d="M4603 14785 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor}/>
<path d="M2615 14757 l-80 -42 360 -3 c198 -2 389 0 425 4 l65 7 -80 38 -80
38 -265 0 -265 0 -80 -42z" fill={solarColor}/>
<path d="M6630 14690 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z" fill={svgColor}/>
<path d="M4602 14620 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M6630 14575 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5
0 -10 -7 -10 -15z" fill={svgColor}/>
<path d="M4602 14470 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M2500 14355 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
-6 4 -10 -8 -10 -30z" fill={solarColor}/>
<path d="M2370 14347 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
-20 6z" fill={solarColor}/>
<path d="M6630 14345 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5
0 -10 -7 -10 -15z" fill={svgColor}/>
<path d="M2622 14338 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
-7z" fill={solarColor}/>
<path d="M2445 14256 c-111 -49 -125 -205 -25 -276 l28 -20 21 69 c28 92 38
101 114 101 81 0 94 8 74 46 -20 38 -44 60 -90 79 -44 18 -82 19 -122 1z" fill={solarColor}/>
<path d="M2260 14250 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
-10z" fill={solarColor}/>
<path d="M2708 14244 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
-31 -4z" fill={solarColor}/>
<path d="M6630 14190 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20
-5 0 -10 -9 -10 -20z" fill={svgColor}/>
<path d="M4602 14160 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M5716 14124 c-255 -62 -440 -331 -423 -616 14 -222 135 -411 321
-504 287 -141 625 16 733 341 23 69 27 97 27 200 0 105 -3 130 -27 198 -100
287 -363 446 -631 381z m229 -49 c85 -23 152 -62 220 -130 217 -216 219 -578
5 -796 -193 -197 -469 -198 -666 -4 -217 214 -217 585 1 800 126 125 282 171
440 130z" fill={svgColor}/>
<path d="M2240 14110 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={solarColor}/>
<path d="M2506 14043 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor}/>
<path d="M2666 14059 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
c-63 0 -64 0 -70 -31z" fill={solarColor}/>
<path d="M2837 14083 c-4 -3 -7 -26 -7 -50 l0 -43 80 0 80 0 0 50 0 50 -73 0
c-41 0 -77 -3 -80 -7z" fill={solarColor}/>
<path d="M3030 14040 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor}/>
<path d="M3184 14073 c2 -10 7 -33 11 -50 l7 -33 64 0 c70 0 71 1 52 61 l-11
39 -64 0 c-57 0 -64 -2 -59 -17z" fill={solarColor}/>
<path d="M5100 14044 c0 -3 11 -22 25 -42 31 -45 31 -56 0 -111 -14 -24 -24
-45 -22 -47 1 -2 54 20 117 49 l114 51 -109 53 c-111 52 -125 58 -125 47z" fill={svgColor}/>
<path d="M6630 14040 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z" fill={svgColor}/>
<path d="M4602 14010 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" fill={svgColor}/>
<path d="M2289 14001 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
-41 -6z" fill={solarColor}/>
<path d="M2546 13951 l-69 -6 -18 -53 -18 -54 72 7 c39 4 75 10 78 14 4 3 11
27 17 54 5 26 9 46 8 45 0 -1 -32 -4 -70 -7z" fill={solarColor}/>
<path d="M2641 13923 c-19 -68 -18 -70 60 -77 39 -4 73 -5 76 -3 2 3 8 30 12
61 l8 56 -73 0 -73 0 -10 -37z" fill={solarColor}/>
<path d="M4669 13949 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M4829 13949 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M5029 13949 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M2827 13943 c-4 -3 -7 -28 -7 -55 l0 -48 83 0 c45 0 87 4 94 8 7 4 9
24 6 55 l-6 47 -82 0 c-45 0 -85 -3 -88 -7z" fill={solarColor}/>
<path d="M3040 13901 c0 -56 7 -61 103 -61 l58 0 -7 38 c-12 67 -18 72 -89 72
l-65 0 0 -49z" fill={solarColor}/>
<path d="M3214 13924 c4 -15 10 -39 13 -55 5 -29 7 -29 74 -29 37 0 70 3 72 8
2 4 -3 28 -10 55 l-14 47 -71 0 -70 0 6 -26z" fill={solarColor}/>
<path d="M2394 13932 c-18 -11 -35 -50 -25 -56 5 -3 16 6 26 20 17 27 17 48
-1 36z" fill={solarColor}/>
<path d="M6634 13909 c-3 -6 -1 -16 5 -22 8 -8 11 -5 11 11 0 24 -5 28 -16 11z" fill={svgColor}/>
<path d="M6393 13833 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M6533 13833 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M2417 13757 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor}/>
<path d="M2622 13798 c-13 -17 -33 -99 -26 -110 3 -4 43 -8 90 -8 l85 0 -3 63
-3 62 -66 3 c-46 2 -69 -1 -77 -10z" fill={solarColor}/>
<path d="M2808 13748 c-3 -29 -3 -56 -1 -60 2 -5 51 -8 109 -8 l104 0 0 38 c0
82 -1 82 -110 82 l-98 0 -4 -52z" fill={solarColor}/>
<path d="M3047 13793 c-3 -5 -2 -32 0 -60 l6 -53 83 0 c47 0 86 5 89 10 4 6 1
33 -5 60 l-12 50 -78 0 c-44 0 -81 -3 -83 -7z" fill={solarColor}/>
<path d="M3240 13798 c1 -2 7 -28 14 -58 l12 -55 69 -3 c37 -2 72 1 78 7 6 6
5 27 -3 60 l-12 51 -79 0 c-43 0 -79 -1 -79 -2z" fill={solarColor}/>
<path d="M5030 13674 c0 -3 11 -22 25 -42 31 -45 31 -56 0 -111 -14 -24 -24
-45 -22 -47 1 -2 54 20 117 49 l114 51 -109 53 c-111 52 -125 58 -125 47z" fill={svgColor}/>
<path d="M2382 13633 c-17 -33 -43 -134 -37 -143 3 -6 43 -10 89 -10 l82 0 13
63 c7 34 15 72 18 85 5 21 3 22 -76 22 -66 0 -82 -3 -89 -17z" fill={solarColor}/>
<path d="M2586 13641 c-3 -5 -12 -40 -20 -77 -11 -52 -12 -71 -3 -76 7 -4 54
-8 105 -8 l92 0 0 39 c0 21 3 59 6 85 l7 46 -91 0 c-50 0 -93 -4 -96 -9z" fill={solarColor}/>
<path d="M2796 13589 c-12 -120 -23 -109 114 -109 l120 0 0 39 c0 21 -3 59 -6
85 l-7 46 -107 0 -107 0 -7 -61z" fill={solarColor}/>
<path d="M3056 13603 c14 -128 9 -123 117 -123 98 0 102 4 86 76 -20 96 -17
94 -119 94 l-90 0 6 -47z" fill={solarColor}/>
<path d="M3274 13633 c3 -10 10 -40 16 -68 19 -90 13 -85 93 -84 109 1 108 0
83 89 l-22 75 -88 3 c-80 3 -87 1 -82 -15z" fill={solarColor}/>
<path d="M3960 13580 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10
-19 0 -35 -4 -35 -10z" fill={svgColor}/>
<path d="M4110 13580 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={svgColor}/>
<path d="M4260 13580 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={svgColor}/>
<path d="M4400 13580 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z" fill={svgColor}/>
<path d="M4629 13579 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M4789 13579 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M4959 13579 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M2890 13365 c0 -84 0 -85 25 -85 25 0 25 1 25 85 0 84 0 85 -25 85
-25 0 -25 -1 -25 -85z" fill={solarColor}/>
<path d="M6458 13403 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor}/>
<path d="M6598 13403 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M5070 13314 c0 -3 11 -22 25 -42 31 -45 31 -56 0 -111 -14 -24 -24
-45 -22 -47 1 -2 54 20 117 49 l114 51 -109 53 c-111 52 -125 58 -125 47z" fill={svgColor}/>
<path d="M6663 13275 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor}/>
<path d="M2565 13197 l-80 -42 360 -3 c198 -2 389 0 425 4 l65 7 -80 38 -80
38 -265 0 -265 0 -80 -42z"fill={solarColor}/>
<path d="M4999 13219 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M4860 13210 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" fill={svgColor}/>
<path d="M6662 13130 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M4600 13126 c0 -22 3 -27 11 -19 8 8 8 16 0 30 -9 16 -10 14 -11 -11z" fill={svgColor}/>
<path d="M6662 12980 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M8195 12949 c-21 -19 -66 -62 -101 -96 -35 -35 -66 -63 -70 -63 -3 0
-34 -28 -68 -62 -35 -35 -115 -112 -179 -173 -65 -60 -117 -114 -117 -118 0
-4 8 -10 18 -14 9 -3 25 -12 34 -20 15 -13 24 -7 92 61 42 42 79 76 82 76 3 0
36 30 73 68 61 60 123 118 235 220 l37 34 24 -24 c12 -13 58 -54 100 -93 125
-113 256 -237 299 -282 22 -24 44 -43 50 -43 6 0 17 -10 25 -21 l13 -22 24 29
c13 16 23 33 24 37 0 9 -38 46 -226 222 -71 66 -158 148 -193 182 -35 35 -68
63 -72 63 -4 0 -21 16 -37 36 l-30 36 -37 -33z" fill={loadColor}/>
<path d="M7840 12804 l0 -107 48 49 c63 64 82 93 82 125 0 32 -15 39 -81 39
l-49 0 0 -106z" fill={loadColor}/>
<path d="M4600 12846 c0 -22 3 -27 11 -19 8 8 8 16 0 30 -9 16 -10 14 -11 -11z" fill={svgColor}/>
<path d="M6663 12835 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor}/>
<path d="M2520 12735 c0 -22 4 -34 10 -30 6 3 10 17 10 30 0 13 -4 27 -10 30
-6 4 -10 -8 -10 -30z" fill={solarColor}/>
<path d="M8165 12713 c-33 -31 -120 -115 -192 -185 l-133 -129 0 -278 0 -278
120 -8 c65 -3 124 -4 130 0 6 4 10 48 10 108 0 159 -9 148 134 145 l121 -3 9
-129 9 -128 121 7 c67 4 125 11 130 15 5 5 7 128 4 274 l-4 264 -50 53 c-27
28 -58 60 -69 70 -11 10 -76 72 -145 139 -68 66 -127 120 -130 120 -3 0 -32
-26 -65 -57z" fill={loadColor}/>
<path d="M2390 12727 c0 -23 18 -57 30 -57 16 0 11 26 -10 51 -17 21 -19 22
-20 6z" fill={solarColor}/>
<path d="M2642 12718 c-14 -14 -16 -48 -4 -48 8 0 32 43 32 55 0 9 -16 5 -28
-7z" fill={solarColor}/>
<path d="M6662 12690 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M4601 12670 c0 -29 1 -32 10 -17 7 11 7 23 0 35 -9 14 -10 11 -10
-18z" fill={svgColor}/>
<path d="M2465 12636 c-111 -49 -125 -205 -25 -276 l28 -20 21 69 c28 92 38
101 114 101 81 0 94 8 74 46 -20 38 -44 60 -90 79 -44 18 -82 19 -122 1z" fill={solarColor}/>
<path d="M2280 12630 c0 -13 60 -43 68 -35 9 8 -36 45 -54 45 -8 0 -14 -4 -14
-10z" fill={solarColor}/>
<path d="M2728 12624 c-29 -15 -37 -34 -15 -34 20 0 50 25 46 38 -3 7 -13 6
-31 -4z" fill={solarColor}/>
<path d="M6662 12545 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor}/>
<path d="M4601 12500 c0 -29 1 -32 10 -17 7 11 7 23 0 35 -9 14 -10 11 -10
-18z" fill={svgColor}/>
<path d="M2260 12490 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={solarColor}/>
<path d="M2526 12423 c-9 -26 -16 -48 -16 -50 0 -7 129 -3 133 5 3 4 8 26 12
50 l7 42 -60 0 -60 0 -16 -47z" fill={solarColor}/>
<path d="M2686 12439 c-13 -68 -12 -69 58 -69 70 0 76 5 76 66 l0 34 -64 0
c-63 0 -64 0 -70 -31z" fill={solarColor}/>
<path d="M2857 12463 c-4 -3 -7 -26 -7 -50 l0 -43 80 0 80 0 0 50 0 50 -73 0
c-41 0 -77 -3 -80 -7z" fill={solarColor}/>
<path d="M3050 12420 l0 -50 70 0 c77 0 77 0 59 63 l-10 37 -59 0 -60 0 0 -50z" fill={solarColor}/>
<path d="M3204 12453 c2 -10 7 -33 11 -50 l7 -33 64 0 c70 0 71 1 52 61 l-11
39 -64 0 c-57 0 -64 -2 -59 -17z" fill={solarColor}/>
<path d="M6662 12390 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M2309 12381 c-13 -11 -21 -22 -18 -26 10 -9 59 17 59 32 0 18 -14 16
-41 -6z" fill={solarColor}/>
<path d="M4612 12330 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M2566 12331 l-69 -6 -18 -53 -18 -54 72 7 c39 4 75 10 78 14 4 3 11
27 17 54 5 26 9 46 8 45 0 -1 -32 -4 -70 -7z" fill={solarColor}/>
<path d="M2661 12303 c-19 -68 -18 -70 60 -77 39 -4 73 -5 76 -3 2 3 8 30 12
61 l8 56 -73 0 -73 0 -10 -37z" fill={solarColor}/>
<path d="M2847 12323 c-4 -3 -7 -28 -7 -55 l0 -48 83 0 c45 0 87 4 94 8 7 4 9
24 6 55 l-6 47 -82 0 c-45 0 -85 -3 -88 -7z" fill={solarColor}/>
<path d="M3060 12281 c0 -56 7 -61 103 -61 l58 0 -7 38 c-12 67 -18 72 -89 72
l-65 0 0 -49z" fill={solarColor}/>
<path d="M3234 12304 c4 -15 10 -39 13 -55 5 -29 7 -29 74 -29 37 0 70 3 72 8
2 4 -3 28 -10 55 l-14 47 -71 0 -70 0 6 -26z" fill={solarColor}/>
<path d="M2414 12312 c-18 -11 -35 -50 -25 -56 5 -3 16 6 26 20 17 27 17 48
-1 36z" fill={solarColor}/>
<path d="M6662 12245 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor}/>
<path d="M4613 12165 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor}/>
<path d="M2437 12137 c-9 -30 -17 -59 -17 -65 0 -8 26 -12 78 -12 l79 0 12 56
c16 69 11 74 -75 74 l-60 0 -17 -53z" fill={solarColor}/>
<path d="M2642 12178 c-13 -17 -33 -99 -26 -110 3 -4 43 -8 90 -8 l85 0 -3 63
-3 62 -66 3 c-46 2 -69 -1 -77 -10z" fill={solarColor}/>
<path d="M2828 12128 c-3 -29 -3 -56 -1 -60 2 -5 51 -8 109 -8 l104 0 0 38 c0
82 -1 82 -110 82 l-98 0 -4 -52z" fill={solarColor}/>
<path d="M3067 12173 c-3 -5 -2 -32 0 -60 l6 -53 83 0 c47 0 86 5 89 10 4 6 1
33 -5 60 l-12 50 -78 0 c-44 0 -81 -3 -83 -7z" fill={solarColor}/>
<path d="M3260 12178 c1 -2 7 -28 14 -58 l12 -55 69 -3 c37 -2 72 1 78 7 6 6
5 27 -3 60 l-12 51 -79 0 c-43 0 -79 -1 -79 -2z" fill={solarColor}/>
<path d="M6662 12095 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor}/>
<path d="M7160 12104 c0 -3 11 -22 25 -42 31 -45 31 -56 0 -111 -14 -24 -24
-45 -22 -47 1 -2 54 20 117 49 l114 51 -109 53 c-111 52 -125 58 -125 47z" fill={svgColor}/>
<path d="M4612 12020 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor}/>
<path d="M2402 12013 c-17 -33 -43 -134 -37 -143 3 -6 43 -10 89 -10 l82 0 13
63 c7 34 15 72 18 85 5 21 3 22 -76 22 -66 0 -82 -3 -89 -17z" fill={solarColor}/>
<path d="M2606 12021 c-3 -5 -12 -40 -20 -77 -11 -52 -12 -71 -3 -76 7 -4 54
-8 105 -8 l92 0 0 39 c0 21 3 59 6 85 l7 46 -91 0 c-50 0 -93 -4 -96 -9z" fill={solarColor}/>
<path d="M2816 11969 c-12 -120 -23 -109 114 -109 l120 0 0 39 c0 21 -3 59 -6
85 l-7 46 -107 0 -107 0 -7 -61z" fill={solarColor}/>
<path d="M3076 11983 c14 -128 9 -123 117 -123 98 0 102 4 86 76 -20 96 -17
94 -119 94 l-90 0 6 -47z" fill={solarColor}/>
<path d="M3294 12013 c3 -10 10 -40 16 -68 19 -90 13 -85 93 -84 109 1 108 0
83 89 l-22 75 -88 3 c-80 3 -87 1 -82 -15z" fill={solarColor}/>
<path d="M6759 12009 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M6919 12009 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M7089 12009 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z" fill={svgColor}/>
<path d="M4028 12003 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" fill={svgColor}/>
<path d="M4173 12003 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M4323 12003 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M4483 11993 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M2910 11745 c0 -84 0 -85 25 -85 25 0 25 1 25 85 0 84 0 85 -25 85
-25 0 -25 -1 -25 -85z" fill={solarColor}/>
<path d="M2585 11577 l-80 -42 360 -3 c198 -2 389 0 425 4 l65 7 -80 38 -80
38 -265 0 -265 0 -80 -42z" fill={solarColor}/>
</g>
</svg>


        </>
    );
};

export default Load3Svg;
